<script setup>
import { computed, reactive } from 'vue';
import { required, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useI18n } from 'vue-i18n';

import Input from 'next/input/Input.vue';
import TextAreaNext from 'next/textarea/TextArea.vue';

const emit = defineEmits(['submit']);
const { t } = useI18n();

const rules = {
  name: {
    required,
    maxLength: maxLength(255),
  },
  description: {},
};

const state = reactive({
  name: '',
  description: '',
});

const v$ = useVuelidate(rules, state);

const errorMessage = computed(() => {
  if (!v$.value.name.$error) return '';
  if (v$.value.name.maxLength.$invalid) {
    return t('WGPT_MCP_SERVERS.CREATE.FORM.NAME.ERROR_MAX_LENGTH');
  }
  return t('WGPT_MCP_SERVERS.CREATE.FORM.NAME.ERROR');
});

const validate = () => {
  return v$.value.$validate();
};

defineExpose({
  state,
  validate,
});
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="emit('submit')">
    <label>
      {{ $t('WGPT_MCP_SERVERS.CREATE.FORM.NAME.LABEL') }}
      <Input
        v-model.trim="state.name"
        type="text"
        data-testid="mcp-server-name"
        :message="errorMessage"
        :message-type="v$.name.$error ? 'error' : 'info'"
        @input="v$.name.$touch"
      />
    </label>

    <label>
      {{ $t('WGPT_MCP_SERVERS.CREATE.FORM.DESCRIPTION.LABEL') }}
      <TextAreaNext
        v-model.trim="state.description"
        custom-text-area-class="!outline !outline-0"
        data-testid="mcp-server-description"
        rows="3"
      />
    </label>
  </form>
</template>
